<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="part01">
<div class="partHead" id="partHead01">
<a id="page12">
</a><a id="page13">
</a><a id="page14">
</a><a id="page15">
</a><h2 class="partNumber" style="text-indent: 0%;"><a id="page15"><span class="xrefInternal"></span></a><a href="#/005TOC#part_01"><span class="bold">PART I</span></a></h2>
<div class="partEpigraph1" style="margin-left: 0%;">
<p class="partEpigraphText" style="text-indent:0%;"><em class="italic">Let us face the fact that the monastic vocation</em></p>
<p class="partEpigraphText" style="text-indent:0%;"><em class="italic">tends to present itself to the modern world</em></p>
<p class="partEpigraphText" style="text-indent:0%;"><em class="italic">as a problem and as a scandal.</em></p>
<p class="partEpigraphSource" style="margin-left: 0%;"><span class="smallCaps">THOMAS MERTON</span></p></div></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006-part01.vue?4ffed0a2